import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import { cleanAuthLoading, logout } from "./features/auth/authSlice";
import { cleanBalanceHeader } from "./features/menu/menuSlice";

export default function Root() {
  const { isLoggedIn, token } = useSelector((state) => state.auth);
  const [tokenExpired, setTokenExpired] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loc = useLocation();

  const isTokenExpired = (accessToken) => {
    if (!accessToken) return true;

    const decodedToken = accessToken?.length && jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;

    return decodedToken.exp < currentTime;
  };

  useEffect(() => {
    if (!token) {
      setTokenExpired(true);
      dispatch(logout());
      dispatch(cleanBalanceHeader());
      dispatch(cleanAuthLoading());
      navigate("/login");
      return;
    }

    if (isTokenExpired(token)) {
      setTokenExpired(true);
      dispatch(logout());
      dispatch(cleanBalanceHeader());
      dispatch(cleanAuthLoading());
      navigate("/login");
    } else {
      setTokenExpired(false);
    }
  }, [token, dispatch, navigate]);

  const showAuthenticatedShell =
    isLoggedIn &&
    !tokenExpired &&
    window.location.href != "/" &&
    loc?.pathname != "/";

  return (
    <div
      className={`flex flex-col w-full ${
        showAuthenticatedShell ? "weiser-authenticated-root" : ""
      }`}
    >
      <div
        className={`flex flex-col items-start w-full h-full ${
          showAuthenticatedShell ? "weiser-authenticated-main" : ""
        }`}
      >
        <Outlet />
      </div>
    </div>
  );
}
